// extracted by mini-css-extract-plugin
module.exports = {"container":"selectablePills-module--container--2cKC4","pill":"selectablePills-module--pill--_V5jG","isSelected":"selectablePills-module--isSelected--3o9p4"};